import { render, staticRenderFns } from "./RelatedLinkToggle.vue?vue&type=template&id=2cb41b3e&"
import script from "./RelatedLinkToggle.vue?vue&type=script&lang=js&"
export * from "./RelatedLinkToggle.vue?vue&type=script&lang=js&"
import style0 from "./RelatedLinkToggle.vue?vue&type=style&index=0&id=2cb41b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports